import { Button, Flex } from '@aws-amplify/ui-react';
import { MdStar } from 'react-icons/md';
import './StarRating.css';

interface StarRatingProps {
    rating: number;
    maxRating?: number;
    size?: 'small' | 'medium' | 'large';
    readOnly?: boolean;
    onChange?: (rating: number) => void;
}

export default function StarRating({
    rating,
    maxRating = 5,
    size = 'medium',
    readOnly = false,
    onChange
}: StarRatingProps) {
    const getStarSize = () => {
        switch (size) {
            case 'small':
                return { padding: '0.25rem', minWidth: '2rem', fontSize: '1rem' };
            case 'large':
                return { padding: '0.75rem', minWidth: '3rem', fontSize: '1.5rem' };
            default:
                return { padding: '0.5rem', minWidth: '2.5rem', fontSize: '1.2rem' };
        }
    };

    return (
        <Flex gap="xs" alignItems="center">
            {Array.from({ length: maxRating }, (_, i) => i + 1).map((star) => (
                <Button
                    key={star}
                    onClick={() => !readOnly && onChange?.(star)}
                    disabled={readOnly}
                    {...(!readOnly ? {} : { variation: "destructive" })}
                    padding={getStarSize().padding}
                    minWidth={getStarSize().minWidth}
                    size="large"
                    className="star-button"
                >
                    <MdStar
                        size={parseInt(getStarSize().fontSize) * 20}
                        className={`star-icon ${star <= rating ? 'star-rating-selected' : 'star-rating-unselected'}`}
                    />
                </Button>
            ))}
        </Flex>
    );
}
